/* global window, Event */
import React from 'react';
import PropTypes from 'prop-types';

class EventEmitterProvider extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    componentDidMount() {
        setTimeout(() => {
            this.mountEvent = new Event('ServiceToolComponentDidMount');
            window.dispatchEvent(this.mountEvent);
        }, 0);
    }

    render() {
        return this.props.children;
    }
}

export default EventEmitterProvider;



// WEBPACK FOOTER //
// ./src/frontend/components/EventEmitterProvider.jsx